import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-d89b1e1c"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["element-loading-background"];
const _hoisted_2 = {
  class: "left-warp"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["element-loading-background"];
const _hoisted_5 = {
  class: "movies-list"
};
const _hoisted_6 = {
  key: 0,
  class: "pagination"
};
const _hoisted_7 = {
  class: "page-span"
};
import { axiosInstanceAll } from '@/api/instance';
import { vodPlusBaseUrl } from '@/utils';
import { inject, onMounted } from 'vue';
import MoviesOrActorItem from './moviesOrActorItem.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'byProperty',
  emits: ['onCardClick'],

  setup(__props, {
    emit
  }) {
    const searchParams = reactive({
      searchValue: '',
      loading: false,
      paginationConfig: {
        page: 0,
        limit: 10,
        total: 13
      },
      leftWarpLoading: false
    });
    const leftWarpList = ref([]);
    const moviesList = ref([]);
    const leftCurrentSelectItem = ref(null);

    const getLeftListData = async () => {
      console.log('getLeftListData');

      try {
        searchParams.leftWarpLoading = true;
        const {
          subCategoryUrl
        } = currentParams.value;
        const res = await axiosInstanceAll({
          method: 'get',
          url: '/vodPlus' + subCategoryUrl.replace(vodPlusBaseUrl, ''),
          params: {
            usertoken: sessionStorage.getItem('vodPlusToken')
          }
        });
        console.log(res);

        if (res.status == 200) {
          leftWarpList.value = res.data;
          leftCurrentSelectItem.value = res.data.length && res.data[0];
        }
      } catch (error) {}

      searchParams.leftWarpLoading = false;
    };

    const getData = async () => {
      searchParams.loading = true;

      try {
        const {
          programListUrl
        } = leftCurrentSelectItem.value;
        const res = await axiosInstanceAll({
          method: 'get',
          url: '/vodPlus' + programListUrl.replace(vodPlusBaseUrl, ''),
          params: {
            usertoken: sessionStorage.getItem('vodPlusToken'),
            start: searchParams.paginationConfig.page * searchParams.paginationConfig.limit,
            total: searchParams.paginationConfig.limit
          },
          noRepetition: true
        });
        console.log(res);

        if (res.status == 200) {
          moviesList.value = res.data.list;
          searchParams.paginationConfig.total = res.data.totalNum;
          searchParams.loading = false;
        } else {
          searchParams.loading = false;
        }
      } catch (error) {
        if (error.message !== 'canceled') {
          searchParams.loading = false;
        }
      }
    };

    const handlePaginationChange = val => {
      searchParams.paginationConfig.page = val - 1;
      getData();
    };

    const currentLeftIndex = ref(0);

    const handleLeftItemClick = (item, index) => {
      if (currentLeftIndex.value == index) return;
      searchParams.paginationConfig.page = 0;
      currentLeftIndex.value = index;
      leftCurrentSelectItem.value = item;
      getData();
    };

    const onCardClick = item => {
      emit('onCardClick', item);
    };

    onMounted(async () => {
      await getLeftListData();
      getData();
    });
    const currentUiStyleOptions = inject('currentUiStyleOptions');
    const currentParams = inject('currentParams');
    return (_ctx, _cache) => {
      const _component_el_empty = _resolveComponent("el-empty");

      const _component_el_pagination = _resolveComponent("el-pagination");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "all-movies-actor",
        "element-loading-background": _unref(currentUiStyleOptions).bgColor
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leftWarpList.value, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["pointer", currentLeftIndex.value == index ? 'is-active' : '']),
          key: item,
          onClick: $event => handleLeftItemClick(item, index)
        }, _toDisplayString(item.name), 11, _hoisted_3);
      }), 128))])]), _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "right-warp",
        "element-loading-background": _unref(currentUiStyleOptions).bgColor
      }, [_createElementVNode("div", _hoisted_5, [moviesList.value.length && !searchParams.loading ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(moviesList.value, (item, index) => {
        return _openBlock(), _createBlock(MoviesOrActorItem, {
          poster: item.image,
          "program-name": item.name,
          rating: item.rating,
          onClick: $event => onCardClick(item)
        }, null, 8, ["poster", "program-name", "rating", "onClick"]);
      }), 256)) : _createCommentVNode("", true), !moviesList.value.length && !searchParams.leftWarpLoading && !searchParams.loading ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        style: {
          "width": "100%"
        },
        "image-size": 50
      })) : _createCommentVNode("", true)]), searchParams.paginationConfig.total > searchParams.paginationConfig.limit && !searchParams.leftWarpLoading && !searchParams.loading ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_pagination, {
        small: "",
        background: "",
        layout: "slot, prev, pager, next",
        "current-page": searchParams.paginationConfig.page + 1,
        "page-size": searchParams.paginationConfig.limit,
        total: searchParams.paginationConfig.total,
        onCurrentChange: handlePaginationChange
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_7, _toDisplayString(searchParams.paginationConfig.page * searchParams.paginationConfig.limit + 1 + '-' + (searchParams.paginationConfig.total / (searchParams.paginationConfig.page + 1) > searchParams.paginationConfig.limit ? (searchParams.paginationConfig.page + 1) * searchParams.paginationConfig.limit : searchParams.paginationConfig.total)) + " of " + _toDisplayString(searchParams.paginationConfig.total) + " items ", 1)]),
        _: 1
      }, 8, ["current-page", "page-size", "total"])])) : _createCommentVNode("", true)], 8, _hoisted_4)), [[_directive_loading, searchParams.loading]])], 8, _hoisted_1)), [[_directive_loading, searchParams.leftWarpLoading]]);
    };
  }

});